import { NgModule, ModuleWithProviders  } from '@angular/core';
import { WavesDirective } from './waves-effect.directive';

@NgModule({
  declarations: [WavesDirective],
  exports: [WavesDirective]
})

export class WavesModule {
  public static forRoot(): ModuleWithProviders {
    return {ngModule: WavesModule, providers: []};
  }
}



// WEBPACK FOOTER //
// ./src/app/angular-bootstrap-md/waves/waves.module.ts